module.exports = __webpack_public_path__ + "img/logo-ms.849d072c.svg";